<template>
  <v-layout row wrap v-if="screener">
    <!-- Show thumbnail of screener -->
    <v-flex xs12 v-if="screener.thumbnail_url">
      <!-- Film poster -->
      <v-card flat>
        <v-img
          width="100%"
          height="auto"
          v-if="screener.thumbnail_url"
          :src="screener.thumbnail_url"
        ></v-img>

        <v-container
          v-else
          bg
          fill-height
          grid-list-md
          text-xs-center
          class="media_file_container"
        >
          <v-layout row wrap align-center>
            <v-flex>
              <v-icon size="100">$vuetify.icons.rms_image_not_found</v-icon>
              <div class="title secondary--text">
                {{ $t("screener.film.thumbnails.not_available") }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <!-- Show First film thumbnail if thumbnail is not available  -->
    <v-flex xs12 v-else>
      <!-- Film poster -->
      <v-card flat>
        <v-img
          width="100%"
          height="auto"
          v-if="screener.films[0].thumburls"
          :src="screener.films[0].thumburls"
        ></v-img>
        <v-container
          v-else
          bg
          fill-height
          grid-list-md
          text-xs-center
          class="media_file_container"
        >
          <v-layout row wrap align-center>
            <v-flex>
              <v-icon size="100">$vuetify.icons.rms_image_not_found</v-icon>
              <div class="title secondary--text">
                {{ $t("screener.film.thumbnails.not_available") }}
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
    <!-- Content -->
    <v-layout row wrap>
      <v-flex xs12>
        <div class="primary">
          <v-layout row wrap class="pa-3">
            <v-flex xs12 sm9 md8>
              <!-- <v-toolbar v-if="screener.films.length > 1" color="secondary" dark tabs card >
                <template  v-slot:extension>
                  <v-tabs v-model="tab" color="secondary">
                    <v-tabs-slider color="background"></v-tabs-slider>
                    <v-tab href="#overview" class="background--text">{{
                      $t("screener.overview.tab.screener.details")
                    }}</v-tab>
                    <v-tab class="background--text" v-if="screener.films.length > 1" href="#movies">{{
                      $t("screener.overview.tab.screener.movies")
                    }}</v-tab>
                  </v-tabs>
                </template>
                </v-toolbar> -->

                <v-card v-if="screener.films" dark color="primary" width="100%" flat>
                  <v-card-text >
                    <div>
                      <h3 class="display-0 mb-1 font-weight-black" v-if="screener.film_sections && screener.film_sections.length">{{ screener.film_sections[0] }}</h3>
                      <div class="subheading">
                        <span v-if="countryName">
                          {{ countryName }}
                          <span class="px-1">&#8226;</span>
                        </span>
                        <span v-if="screener.films[0].released_year">
                          {{ screener.films[0].released_year }}
                          <span class="px-1">&#8226;</span>
                        </span>
                        <span v-if="screener.films[0].genre[currentLocale]">
                          {{ screener.films[0].genre[currentLocale] }}
                          <span class="px-1">&#8226;</span>
                        </span>
                        <span v-if="screener.films[0].additional_metadata[currentLocale].colorFormat && screener.films[0].additional_metadata[currentLocale].colorFormat.value">
                          {{ screener.films[0].additional_metadata[currentLocale].colorFormat.value }}
                          <span class="px-1">&#8226;</span>
                        </span>
                        <span v-if="screener.films[0].length">
                          <!-- {{ convertFormatSecToFilmLength(screener.films[0].length) }} -->
                          {{ screener.films[0].length }}
                        </span>
                      </div>
                      <div class="screenerTitle">
                        {{ screener.title[currentLocale] }}
                        </div>
                        <div v-if="directorNames" class="mt-1">
                          <span>{{ $t('screener.details.page.header.director.by') }} </span>
                          <span class="subtitle font-weight-black">{{ directorNames }}</span>
                        </div>
                        
                      <div v-if="screener.qa_info && screener.qa_info.qa_datetime" class="py-3 qa-info">
                        <v-layout row wrap>
                          <v-flex xs2 md1 class="qa-image">
                            <v-img
                              src="@/assets/icons/q-and-a-white.png"
                              class="icon"
                              contain
                              height="40%"
                            ></v-img>
                          </v-flex>
                          <v-flex xs10 md11 class="px-2 datetime">
                            <div class="font-weight-bold">
                              <span>{{ moment.utc(screener.qa_info.qa_datetime).local().format("lll") }} </span>
                              <div>
                                <small><b>(</b>{{ getTimeByCompany(screener.qa_info.qa_datetime) }}
                                <b>)</b></small>
                              </div>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                      <v-tabs v-if="screener.films.length > 1" v-model="tab" color="secondary">
                        <v-tabs-slider color="background"></v-tabs-slider>
                        <v-tab href="#overview" class="background--text">{{
                          $t("screener.overview.tab.screener.details")
                        }}</v-tab>
                        <v-tab class="background--text"  href="#movies">{{
                          $t("screener.overview.tab.screener.movies")
                        }}</v-tab>
                      </v-tabs>
                    </div>
                  </v-card-text>
                </v-card>

            </v-flex>
            <v-flex xs12 sm9 md9 class="screener-action right-aligned mobile-left">
              <v-container class="screener-container">
                <v-layout column align-end justify-end fill-height class="screener-layout">
            
                  <!-- Trailer Icon -->
                  <div  v-if="screener.films[0] && screener.films[0].trailer" class="py-3 qa-info trailer-image">
                    <v-layout row wrap>
                      <v-flex xs2 md1 class="qa-image">
                    <v-img
                      src="@/assets/icons/trailer-icon-white.png"
                      class="trailer-icon"
                      contain
                      height="40%"
                      @click="showTrailerpreview({ film: screener.films[0] })"
                    ></v-img>
                  </v-flex>
                  </v-layout>
                  </div>
            
                  <!-- Pricing and Button (Will shift up when trailer icon is not shown) -->
                  <v-flex class="w-100 text-right">
                    <v-layout row align-center justify-end>
                      <v-flex shrink class="mr-3 d-flex align-center primary background--text pricing-info">
                        <div v-if="screener.is_vod_event && screener.monetization_enabled && !isConsumerSubscribed">
                          <span class="same-text-color">{{ $t('vod.header.price.label') }}</span>
                          <h4 class="d-inline-block price-value same-text-color">
                            {{
                              getCurrencySymbol(
                                screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE][0].currency
                              )
                            }}
                            {{
                              screener.monetization[DEFINES.MONETIZATION.PRICING_TYPE.VOD_PURCHASE][0].price
                            }}
                          </h4>
                        </div>
                        <div v-else class="same-text-color">
                          <h3 class="pr-3">{{ $t("vod_event.free") }}</h3>
                      </div>
                      </v-flex>
            
                      <!-- Watch Button -->
                      <v-flex shrink class="d-flex align-center">
                        <ScreenerButton
                            :screener="screener"
                            @onBuyTicket="$emit('onBuyTicket', screener)"
                            @onParticipate="$emit('onParticipate', screener)"
                            @onWatch="$emit('onWatch', screener)"
                            @onBuyVenueTicket="$emit('onBuyVenueTicket', screener)"
                            buttonDisplayMode="text"
                            class="d-inline-block"
                          />
                      </v-flex> 
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
        </div>
        <div>

          <v-tabs-items v-model="tab">
            <v-tab-item value="overview">
              <v-card>
                <v-flex pa-1 class="word-break">
                  <v-layout row wrap class="primary--text">
                    <!-- Description -->
                    <v-divider class="py-2 mx-1"></v-divider> <!-- Divider Above the Panel -->
                    <v-expansion-panel value="true" class="flat-panel">
                      <v-expansion-panel-content :value="isLargeScreen">
                        <template v-slot:header>
                          <div class="bold-header secondary--text">{{ $t('screener.details.synposis') }}</div>
                        </template>
                        <template v-slot:actions>
                          <v-icon color="primary">$vuetify.icons.expand</v-icon>
                        </template>
                        <v-flex
                          :md10="addToCalLink!=null"
                          :class="[
                            $vuetify.breakpoint.width > 959
                              ? $vuetify.rtl
                                ? 'pr-2'
                                : 'pl-2'
                              : '',
                              'mb-2',
                              isSecondaryColorWhite(currentCompany) || currentCompany.id == 56 ? 'black--text' : 'secondary--text'
                          ]"
                        >
                          <!-- User collection description if available -->
                          <div
                            v-if="screener.films.length > 1 && screener.description"
                            class="subheading font-weight-medium text-align ql-editor me-screener-desc secondary--text pa-2"
                            v-html="screener.description[currentLocale]"
                          ></div>
                          <!-- If collection description is not available then use first film description -->
                          <div
                            v-else
                            class="subheading font-weight-medium text-align ql-editor me-screener-desc secondary--text px-4"
                            v-html="screener.films[0].description[currentLocale]"
                          ></div>
                          <!-- Organizing body branding -->
                          <div v-if="screener.logo_url" class="text-xs-left pt-3">
                            <img
                              class="cursor-pointer"
                              :src="screener.logo_url"
                              height="60vh"
                              style="max-width: 100%"
                            />
                          </div>
                        </v-flex>
                      
                    
                    <v-flex v-if="addToCalLink!=null" md2 class="add-calendar text-xs-center" >
                      <div>
                        <v-img
                          src="@/assets/icons/google-calendar.png"
                          class="icon"
                          contain
                          height="50px"
                        ></v-img>
                        <v-btn
                          class="primary primary--text"
                          dark
                          @click="onAddToCal"
                          outline
                          flat
                          small
                          >{{ $t("screener.btn.add_to_cal") }}
                          </v-btn>
                      </div>
                    </v-flex>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                  </v-layout>
                </v-flex>
                <v-divider class="py-2 mx-1"></v-divider> <!-- Divider Above the Panel -->
                <v-expansion-panel class="flat-panel pa-1">
                  <v-expansion-panel-content :value="$vuetify.breakpoint.width >= 959" >
                    <template v-slot:header>
                    <div slot="header" class="bold-header secondary--text">{{ $t('screener.details.cast_&_crew') }}</div>
                    </template>
                    <template v-slot:actions>
                      <v-icon color="primary">$vuetify.icons.expand</v-icon>
                    </template>
                <v-flex class="pa-3">
                  <v-layout row wrap>
                    <v-flex xs4 class="hidden-sm-and-down"></v-flex>
                    <v-flex xs8>
                      <v-container>
                        <div class="credits-grid">
                          <!-- Original Title -->
                          <div v-if="metadata.originalTitle && metadata.originalTitle.value" class="credit-item">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.original.title') }}</h4>
                            <div class="subheading">{{ metadata.originalTitle.value }}</div>
                          </div>
                          <!-- Original Title -->

                          <!-- Director -->
                          <div v-if="directorNames" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.director.name') }}</h4>
                            <div class="subheading">{{ directorNames }}</div>
                          </div>
                          <!-- Director -->

                          <!-- Cast -->
                          <div v-if="metadata.cast && metadata.cast.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.cast') }}</h4>
                            <div class="subheading">{{ metadata.cast.value }}</div>
                          </div>
                          <!-- Cast -->
                          
                          <!-- Screen Play -->
                          <div v-if="metadata.screenplay && metadata.screenplay.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.screenplay') }}</h4>
                            <div class="subheading">{{ metadata.screenplay.value }}</div>
                          </div>
                          <!-- Screen Play -->
                          
                          <!-- Script -->
                          <div v-if="screener.films[0] && screener.films[0].script_writer.en" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.script') }}</h4>
                            <div class="subheading">{{ screener.films[0].script_writer[currentLocale] }}</div>
                          </div>
                          <!-- Script -->
                          
                          <!-- Based On -->
                          <div v-if="metadata.productionDesigner && metadata.productionDesigner.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.productionDesigner') }}</h4>
                            <div class="subheading">{{ metadata.productionDesigner.value }}</div>
                          </div>
                          <!-- Based On -->
                          
                          <!-- Cinematography -->
                          <div v-if="metadata.cinematography && metadata.cinematography.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.cinematography') }}</h4>
                            <div class="subheading">{{ metadata.cinematography.value }}</div>
                          </div>
                          <!-- Cinematography -->
                          
                          <!-- Editing -->
                          <div v-if="metadata.editing && metadata.editing.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.editing') }}</h4>
                            <div class="subheading">{{ metadata.editing.value }}</div>
                          </div>
                          <!-- Editing -->
                          
                          <!-- Costume Design -->
                          <div v-if="metadata.costumeDesign && metadata.costumeDesign.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.costumeDesign') }}</h4>
                            <div class="subheading">{{ metadata.costumeDesign.value }}</div>
                          </div>
                          <!-- Costume Design -->
                          
                          <!-- Set Design -->
                          <div v-if="metadata.setDesign && metadata.setDesign.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.setDesign') }}</h4>
                            <div class="subheading">{{ metadata.setDesign.value }}</div>
                          </div>
                          <!-- Set Design -->
                          
                          <!-- Music -->
                          <div v-if="metadata.music && metadata.music.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.music') }}</h4>
                            <div class="subheading">{{ metadata.music.value }}</div>
                          </div>
                          <!-- Music -->

                          <!-- Sound -->
                          <div v-if="metadata.sound && metadata.sound.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.sound') }}</h4>
                            <div class="subheading">{{ metadata.sound.value }}</div>
                          </div>
                          <!-- Sound -->
                          
                          <!-- Sound Editing -->
                          <div v-if="metadata.soundEditing && metadata.soundEditing.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.soundEditing') }}</h4>
                            <div class="subheading">{{ metadata.soundEditing.value }}</div>
                          </div>
                          <!-- Sound Editing -->
                          
                          <!-- Visual Effect -->
                          <div v-if="metadata.visualEffect && metadata.visualEffect.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.visualEffect') }}</h4>
                            <div class="subheading">{{ metadata.visualEffect.value }}</div>
                          </div>
                          <!-- Visual Effect -->

                          <!-- Visual Effect -->
                          <div v-if="metadata.makeUpHair && metadata.makeUpHair.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.makeUpHair') }}</h4>
                            <div class="subheading">{{ metadata.makeUpHair.value }}</div>
                          </div>
                          <!-- Visual Effect -->

                          <!-- Production -->
                          <div v-if="metadata.production && metadata.production.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.production') }}</h4>
                            <div class="subheading">{{ metadata.production.value }}</div>
                          </div>
                          <!-- Production -->

                          <!-- Producer -->
                          <div v-if="metadata.producer && metadata.producer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.producer') }}</h4>
                            <div class="subheading">{{ metadata.producer.value }}</div>
                          </div>
                          <!-- Producer -->

                          <!-- Co-Production -->
                          <div v-if="metadata.coProduction && metadata.coProduction.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.coProduction') }}</h4>
                            <div class="subheading">{{ metadata.coProduction.value }}</div>
                          </div>
                          <!-- Co-Production -->

                          <!-- Co-Producer -->
                          <div v-if="metadata.coProducer && metadata.coProducer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.coProducer') }}</h4>
                            <div class="subheading">{{ metadata.coProducer.value }}</div>
                          </div>
                          <!-- Co-Producer -->

                          <!-- Supported By -->
                          <div v-if="metadata.supportedBy && metadata.supportedBy.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.supportedBy') }}</h4>
                            <div class="subheading">{{ metadata.supportedBy.value }}</div>
                          </div>
                          <!-- Supported By -->

                          <!-- Executive Producer -->
                          <div v-if="metadata.executiveProducer && metadata.executiveProducer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.executiveProducer') }}</h4>
                            <div class="subheading">{{ metadata.executiveProducer.value }}</div>
                          </div>
                          <!-- Executive Producer -->

                          <!-- Distributor -->
                          <div v-if="metadata.internationalSales && metadata.internationalSales.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.internationalSales') }}</h4>
                            <div class="subheading">{{ metadata.internationalSales.value }}</div>
                          </div>
                          <!-- Distributor -->

                          <!-- International Sales -->
                          <div v-if="screener.films[0] && screener.films[0].sales_agent.en" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.salesAgent') }}</h4>
                            <div class="subheading">{{ screener.films[0].sales_agent.en }}</div>
                          </div>
                          <!-- International Sales -->
                          
                          <!-- Check imbd -->
                          <div v-if="screener.films[0] && screener.films[0].imdb_ref" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.source') }}</h4>
                            <div class="subheading"><a :href="screener.films[0].imdb_ref" target="_blank" rel="noopener noreferrer">{{ $t('screener.overview.page.metadata.imdb') }} </a></div>
                          </div>
                          <!-- Check imbd -->

                        </div>
                      </v-container>
                      
                      <!-- <v-layout row wrap>
                        <v-flex sm4 xs12 class="px-2">
                           <div v-if="metadata.originalTitle && metadata.originalTitle.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.original.title') }}</h4>
                            <div class="subheading">{{ metadata.originalTitle.value }}</div>
                          </div>
                            
                           <div v-if="filmLanguages" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.languages') }}</h4>
                            <div class="subheading">{{ filmLanguages }}</div>
                          </div>
                          

                           <div v-if="metadata.screenplay && metadata.screenplay.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.screenplay') }}</h4>
                            <div class="subheading">{{ metadata.screenplay.value }}</div>
                          </div>
                            
                          <div v-if="metadata.editing && metadata.editing.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.editing') }}</h4>
                            <div class="subheading">{{ metadata.editing.value }}</div>
                          </div>
                          <div v-if="metadata.costumeDesign && metadata.costumeDesign.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.costumeDesign') }}</h4>
                            <div class="subheading">{{ metadata.costumeDesign.value }}</div>
                          </div>
                          <div v-if="metadata.setDesign && metadata.setDesign.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.setDesign') }}</h4>
                            <div class="subheading">{{ metadata.setDesign.value }}</div>
                          </div>
                          <div v-if="metadata.music && metadata.music.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.music') }}</h4>
                            <div class="subheading">{{ metadata.music.value }}</div>
                          </div>
                        </v-flex>
                        <v-flex sm4 xs12 class="px-2">
                          
                          <div v-if="directorNames" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.director.name') }}</h4>
                            <div class="subheading">{{ directorNames }}</div>
                          </div>
                          
                          
                          <div v-if="metadata.cinematography && metadata.cinematography.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.cinematography') }}</h4>
                            <div class="subheading">{{ metadata.cinematography.value }}</div>
                          </div>
                          
                          
                           
                          <div v-if="metadata.sound && metadata.sound.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.sound') }}</h4>
                            <div class="subheading">{{ metadata.sound.value }}</div>
                          </div>
                          <div v-if="metadata.production && metadata.production.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.production') }}</h4>
                            <div class="subheading">{{ metadata.production.value }}</div>
                          </div>
                          <div v-if="metadata.producer && metadata.producer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.producer') }}</h4>
                            <div class="subheading">{{ metadata.producer.value }}</div>
                          </div>
                          <div v-if="metadata.coProduction && metadata.coProduction.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.coProduction') }}</h4>
                            <div class="subheading">{{ metadata.coProduction.value }}</div>
                          </div>
                          <div v-if="metadata.coProducer && metadata.coProducer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.coProducer') }}</h4>
                            <div class="subheading">{{ metadata.coProducer.value }}</div>
                          </div>
                          <div v-if="metadata.supportedBy && metadata.supportedBy.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.supportedBy') }}</h4>
                            <div class="subheading">{{ metadata.supportedBy.value }}</div>
                          </div>
                          <div v-if="metadata.executiveProducer && metadata.executiveProducer.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.executiveProducer') }}</h4>
                            <div class="subheading">{{ metadata.executiveProducer.value }}</div>
                          </div>
                          <div v-if="metadata.soundEditing && metadata.soundEditing.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.soundEditing') }}</h4>
                            <div class="subheading">{{ metadata.soundEditing.value }}</div>
                          </div>
                          <div v-if="metadata.visualEffect && metadata.visualEffect.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.visualEffect') }}</h4>
                            <div class="subheading">{{ metadata.visualEffect.value }}</div>
                          </div>
                          <div v-if="screener.films[0] && screener.films[0].script_writer" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.script') }}</h4>
                            <div class="subheading">{{ screener.films[0].script_writer }}</div>
                          </div>
                        </v-flex>
                        <v-flex sm4 xs12 class="px-2">
                          
                          <div v-if="metadata.cast && metadata.cast.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.cast') }}</h4>
                            <div class="subheading">{{ metadata.cast.value }}</div>
                          </div>
                          

                          <div v-if="metadata.internationalSales && metadata.internationalSales.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.internationalSales') }}</h4>
                            <div class="subheading">{{ metadata.internationalSales.value }}</div>
                          </div>
                          <div v-if="metadata.productionDesigner && metadata.productionDesigner.value" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.productionDesigner') }}</h4>
                            <div class="subheading">{{ metadata.productionDesigner.value }}</div>
                          </div>
                          <div v-if="screener.films[0] && screener.films[0].sales_agent" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.salesAgent') }}</h4>
                            <div class="subheading">{{ screener.films[0].sales_agent }}</div>
                          </div>
                          <div v-if="screener.films[0] && screener.films[0].imdb_ref" class="mb-3">
                            <h4 class="subheading font-weight-black">{{ $t('screener.overview.page.metadata.source') }}</h4>
                            <div class="subheading"><a :href="screener.films[0].imdb_ref" target="_blank" rel="noopener noreferrer">{{ $t('screener.overview.page.metadata.imdb') }} </a></div>
                          </div>
                        </v-flex>
                      </v-layout> -->
                      
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-divider class="py-2 mx-1"></v-divider> <!-- Divider Above the Panel -->
            <v-expansion-panel class="flat-panel responsive-padding pa-1">
              <v-expansion-panel-content :value="$vuetify.breakpoint.width >= 959" >
                <template v-slot:header>
                <div slot="header" class="bold-header secondary--text">{{ $t('screener.overview.page.section.film.awards') }}</div>
                </template>
                <template v-slot:actions>
                  <v-icon color="primary">$vuetify.icons.expand</v-icon>
                </template>
                <v-flex class="pa-3">
                  <div v-if="screener.films[0].awards[currentLocale]">
                    <div
                        class="subheading font-weight-medium text-align ql-editor me-screener-desc secondary--text"
                        v-html="screener.films[0].awards[currentLocale]"
                      ></div>
                  </div>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
                <v-divider class="py-2 mx-2"></v-divider>
                <v-expansion-panel class="flat-panel pa-1 pb-2 mb-2">
                  <v-expansion-panel-content :value="$vuetify.breakpoint.width >= 959" class="expansion-panel-fix">
                    <template v-slot:header>
                    <div slot="header" class="bold-header secondary--text">{{ $t('screener.overview.page.section.film.director.bio') }}</div>
                    </template>
                    <template v-slot:actions>
                      <v-icon color="primary">$vuetify.icons.expand</v-icon>
                    </template>
                    <v-flex class="pa-4" v-if="screener.films[0].directors && screener.films[0].directors.length">
                      <div>
                        <v-layout  row wrap>
                          <v-flex class="px-3 director-image-container" md2 xs6  v-for="(director, index) in screener.films[0].directors"  :key="index">
                            <v-img
                              :src="director.profile_url"
                              class="director-image cursor-pointer"
                              contain
                              @click="viewFilmMakerProfile(director.id)"
                            ></v-img>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="screener.films.length > 1" value="movies">
              <FilmList
                @watchTrailer="showTrailerpreview"
                :screener="screener"
                :showDescription="true"
              ></FilmList>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </v-flex>
    </v-layout>



    <!-- Trailer popup -->
    <v-dialog
      max-width="80vmin"
      v-if="showPreview"
      v-model="showPreview"
      persistent
    >
      <v-card>
        <v-card-title>
          <div class="title primary--text">
            {{ $t("screener.trailer.preview.title") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            small
            dark
            icon
            color="primary background--text"
            @click="hideTrailerpreview"
            class="mx-0"
          >
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <PreviewTrailer
            v-if="film.trailer"
            :url="film.trailer"
          ></PreviewTrailer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PreviewTrailer from "@/components/screener/PreviewTrailer.vue";
import ZoomInfo from "@/components/screener/Zoom";
import FilmList from "./FilmList";
import { isSecondaryColorWhite } from "@/helpers";
import DEFINES from '@/defines'
import { utcToTz, prepareMetaDataInOrder } from "@/helpers";
import { getAddToCalLink } from "@/helpers";
import { convertFormatSecToFilmLength } from "../../helpers";
import PayPalDonation from "@/components/monetization/PayPalDonation";
import { currencySymbol } from "@/mixins/currencySymbol";
import ScreenerButton from "./ScreenerButton.vue";

export default {
  name: "Screener",
  props: {
    screener: {
      type: Object,
      default: null,
    },
    is_login_compo: {
      type: Boolean,
      default: false,
    },
    eventPrefix: {
      type: String,
      default: 'screener'
    }
  },
  components: {
    PreviewTrailer,
    ZoomInfo,
    FilmList,
    PayPalDonation,
    ScreenerButton
  },
  mixins: [currencySymbol],
  data() {
    return {
      items: [
        { label: "Original Title", value: "დასაწყისი" },
        { label: "Director", value: "Christopher Nolan" },
        { label: "Screenplay", value: "Dea Kulumbegashvili, Rati Onel" },
        { label: "Cinematography", value: "Marco Dante" },
        { label: "Editing", value: "Giulia Moscar" },
        { label: "Sound", value: "Francesco Mollo" }
      ],
      showPreview: false,
      tab: "overview",
      film: null,
      videoOptions: {
        preload: "auto",
        controls: true,
        sources: [
          {
            type: "video/youtube",
            src: "https://www.youtube.com/watch?v=VakbpfZdjbE",
          },
        ],
      },
      panels: false, 
    };
  },
  computed:{
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone",
    }),
    ...mapGetters("screening", {
      isScreeningPaid: "isScreeningPaid"
    }),
    ...mapGetters("consumer", {
      isConsumerEnrolled: "isEnrolled",
      isConsumerPurchased: "isPurchased",
      isConsumerSubscribed: "isSubscribed"
    }),
    ...mapGetters("app", {
      isEmbedMode: "isEmbedMode",
    }),
    isCreditOrTrailerAvailable(){
      return (this.screener &&
      this.screener.films.length == 1 &&
      (this.screener.films[0].director_name || this.screener.films[0].producer_name || this.screener.films[0].trailer));
    },
    ...mapState({
      currentCompany: (state) => state.company.company,
    }),
    countryName() {
      if(!this.screener.films[0].countries){
        return null
      }

      const countryCodes = this.screener.films[0].countries;
      const validCountries = DEFINES.COUNTRIES.filter(country => countryCodes.includes(country.code));
      
      if (validCountries.length === 0) {
        return null;
      }

      const countriesString = validCountries
        .map(country => this.$t(`country.${country.code.toLowerCase()}.name`))
        .join(', ');
      
      return countriesString.replace(/,\s*$/, '');
    },
    startTimeByCompany() {
      return utcToTz(
        this.screener.screening_starts_at,
        this.timezone,
        "MMM DD, YYYY HH:mm z"
      );
    },
    addToCalLink() {
      return getAddToCalLink(this.screener);
    },
    metadata() {
      return prepareMetaDataInOrder(this.screener)
    },
    directorNames() {
      if(this.screener.films[0] && this.screener.films[0].directors){
        return this.screener.films[0].directors.map((director) => director.name[this.currentLocale]).join(', ')
      }
    },
    filmLanguages() {
      const filmLangCode = this.screener.films[0] ? this.screener.films[0].film_languages : null;
      if(!filmLangCode){
        return null
      }
      const filmLanguages = DEFINES.COUNTRY_LANGUAGES.filter(lang =>filmLangCode.includes(lang.code))
      const languageString =  filmLanguages.map(lang => lang.name).join(', ');
      return languageString.replace(/,\s*$/, '');
    },
    currentLocale() {
      return this.$i18n.locale;
    },
    subtitleLanguages() {
      const subtitleLangCode = this.screener.films[0].subtitle_languages;
      if(!subtitleLangCode){
        return null
      }
      const languageString = subtitleLangCode.map(langCode => this.$t(`screener.details.subtitle_languages.${langCode}`)).join(', ')
      return languageString.replace(/,\s*$/, '');
    },
    isLargeScreen() {
      return this.$vuetify.breakpoint.width > 959; 
    },
  },
  mounted() {
    console.log("Initial state:", this.isLargeScreen()); 
  },
  created(){
    this.loadQuillCss();
  },
  methods: {
    isSecondaryColorWhite: isSecondaryColorWhite,
    loadQuillCss(){
      let link = document.createElement("link");
      link.setAttribute("href", "https://cdn.quilljs.com/1.2.6/quill.snow.css");
      link.setAttribute("rel", "stylesheet");
      document.head.appendChild(link);
    },

    showTrailerpreview(event) {
      this.showPreview = true;
      this.film = event.film;
    },
    hideTrailerpreview() {
      this.showPreview = false;
      this.videoOptions.sources[0].src = null;
      this.videoOptions.sources[0].type = null;
      this.film = null;
    },
    getTimeByCompany(datetime){
      return utcToTz(
        datetime,
        this.timezone,
        "MMM DD, YYYY HH:mm z"
      );
    },
    onAddToCal() {
      window.open(this.addToCalLink, "_blank");
    },
    viewFilmMakerProfile(filmMakerId){
      if(!filmMakerId){
        return;
      }
      this.$router.push({
        name: "film.maker.profile",
        params: {
          filmMakerId: filmMakerId
        }
      });
    },
    convertFormatSecToFilmLength
  },
};
</script>

<style>
.media_file_container {
  height: 100%;
  position: relative;
  width: 100%;
  background-color: #e2e2e2;
}
.text-align {
  text-align: justify;
}
.video-js {
  width: 100% !important;
  height: 40vmin;
}
.word-break {
  word-break: break-word;
}

.me-screener-desc img{
  max-width: 100%;
}

.screener-action .icon {
  max-height: 100px;
  cursor: pointer;
  /* max-height: 100px;
  height: auto;
  width: 100%; */
}
.qa-info .datetime,.qa-info .qa-image {
  align-content: center;
}
.qa-info .qa-image {
  align-self: flex-start;
}
.add-calendar {
  align-content: center;
}
.credits-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.screenerTitle {
  font-size: 30px;
  line-height: 1em;
  font-weight: 900;
}
.screener-layout {
  width: 100%;
  align-items: flex-end !important;
}

@media (max-width: 600px) {
  .credits-grid {
    grid-template-columns: 1fr;
  }
}

.credit-item {
  margin-bottom: 16px;
}
.screener-action {
  flex: 0 0 auto;
  max-width: fit-content; 
  align-self: flex-start;
}

.screener-container {
  display: flex;
  flex-direction: column;
  max-width: fit-content; 
  padding: 0; 
  margin: 0; 
  align-self: flex-end; 
}

.right-aligned {
  flex: 0 0 auto !important;
  max-width: fit-content !important;
  margin-left: auto !important;
}


@media (max-width: 960px) {
  .mobile-left {
    justify-content: flex-start !important;
    margin-left: 0 !important;
  }

  .screener-layout {
    width: 100%;
    align-items: flex-start !important;
  }

  .trailer-icon {
    height: 42px !important;
    width: 58px !important;
    cursor: pointer;
  }
  .director-image-container {
    max-width: 50%;
  }
  
  .director-image {
    max-width: 140px;
    max-height: 140px;
  }
  
}
/* Trailer Icon */
.trailer-icon-wrapper {
  min-height: 70px;
}

.trailer-icon {
  height: 90px;
  width: 90px;
  cursor: pointer;
  align-content: center;
  align-self: flex-start;
}
@media (max-width: 412px) {
  .trailer-icon {
    max-height: 52.26px; 
    max-width: 52px;
  }
  .director-image-container {
    max-width: 50%;
  }
  
  .director-image {
    max-width: 140px;
    max-height: 140px;
  }
}
/* Pricing Section */
.pricing-info {
  margin-right: 12px;
}

.price-value {
  display: inline-block;
}

.flat-panel {
  background: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.flat-panel .v-expansion-panel__container {
  background: transparent !important;
}
.flat-panel .v-expansion-panel__header {
  background: transparent !important;
  border-bottom: none !important;
}
.flat-panel .v-expansion-panel__body {
  background: transparent !important;
}

.bold-header {
  font-weight: bold !important;
  font-size: 16px;
}

.same-text-color {
  color: inherit !important; 
}

.theme--dark .same-text-color {
  color: var(--v-secondary-base) !important;
}
.director-image-container {
  width: 100%; 
  height: 100%; 
  display: flex;
  justify-content: center;
  align-items: center;
}

.director-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  flex-shrink: 0;
}

.expansion-panel-fix {
  overflow: visible !important;
}

</style>
